<div class="modal-dialog">
  <div class="modal-content">

    <div class="modal-header">
        <h4 class="modal-title" id="myCenterModalLabel">{{ 'LABELS.DEDUCTION_FOR' | translate}} {{scfField.desc}}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <div class="vidContainer">
        <div class="overFlowDiv borderBottom">
          <form style="max-height: 300px;">
            <div class="row" class="vidRow" *ngFor="let vid of filteredVidList" (click)="setVidSelection(vid)"
              [attr.selected]="vid.selected">
              <div class="col-1"  class="text-center">
                <ion-icon name="checkmark-circle" [color]="vid.selected ? 'primary' : 'dark'"></ion-icon>
              </div>
              <div class="col-11" >
                <div class="row">
                  <div class="col-12">
                    {{vid.vid}} - {{vid.ptn}} - {{vid.des}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" >
                    {{vid.amt | inrdisplay}}
                  </div>
                  <div class="col-6" >
                    {{vid.bDate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row" class="ion-padding centerRow text-center" *ngIf="!vidList.length">
              <div class="col-12" >
                {{ 'LABELS.NO_VIDS_FOUND' | translate}} {{scfField.desc}}.
              </div>
            </div>
          </form>
        </div>
        <div class="row" class="centerRow">
          <div class="col-12" class="text-right"> {{ 'LABELS.ENTER_DEDUCTION_AMOUNT' | translate}}</div>
          <div class="col-12">
            <input type="text" [name]="scfField.key" class="frmInput" [(ngModel)]="deductionAmount"
              [disabled]="!totalVidsSelected" [placeholder]="scfField.desc" appNumberOnly
              numericType="decimal" autocomplete="off">
          </div>
        </div>
        <div class="row" class="ion-no-padding text-center">
          <div class="col-12" >
            <ion-text color="danger" *ngIf="showAmountError">
              <p class="ion-padding-start">
                {{ 'LABELS.AMOUNT_SHOULD_BE_LESS' | translate}}
              </p>
            </ion-text>
            <ion-text color="danger" *ngIf="showAmountExceedError">
              <p class="ion-padding-start">
                {{ 'LABELS.AMOUNT_ENTERED_SHOULD_NOT_EXCEED_VID_SELECTION_AMOUNT' | translate}} ({{selectedVidAmt | inrdisplay}}).
              </p>
            </ion-text>
            <ion-text color="danger" *ngIf="!totalVidsSelected && vidList.length && !parseFloat(deductionAmount)">
              <p class="ion-padding-start">
                {{ 'LABELS.SELECT_AT_LEAST_ONE_VID' | translate}}
              </p>
            </ion-text>
            <ion-text *ngIf="totalVidsSelected">
              <p class="ion-padding-start" color="primary">
                {{totalVidsSelected}}  {{ 'LABELS.VIDS_SELECTED' | translate}}
              </p>
            </ion-text>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <div class="row button-list">
        <div class="col-12">
          <button class="btn  fis-btn" (click)="close()">
            {{ 'LABELS.CLOSE' | translate}}
          </button>
        </div>
        <div class="col-12">
          <button class="btn  fis-btn" (click)="close(true)" [disabled]="formIsInValid()">
            {{ 'LABELS.DONE' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
